import { InjectionToken } from '@angular/core'
import { HttpContextToken } from '@angular/common/http'

// Application config
export const APP_CONFIG = new InjectionToken('APP_CONFIG')

export const SKIP_401_RETRY = new HttpContextToken<boolean>(() => false)
